import React from 'react';

import { SearchType } from 'app/constants';

import useStyles from './styles';

import { searchTypeOptions } from '../../constants';

interface Props {
    value?: SearchType;
    onChange?: (value: SearchType) => void;
    className?: string;
}

const [defaultOption] = searchTypeOptions;

const SearchTypeTabs: React.FC<Props> = ({ className, value = defaultOption.value, onChange }) => {
    const { classes, cx } = useStyles();

    const handleClick = (type: SearchType) => {
        if (type !== value) {
            onChange?.(type);
        }
    };

    return (
        <div className={cx(classes.root, className)}>
            {searchTypeOptions.map((option) => {
                const isSelected = option.value === value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        onClick={() => handleClick(option.value)}
                        className={cx(classes.tab, { [classes.tabSelected]: isSelected })}
                        data-testid={`${option.value}SearchTypeTab`}
                    >
                        {option.label.short}
                    </button>
                );
            })}
        </div>
    );
};

export default React.memo(SearchTypeTabs);
